/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartStock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 20v2H2v-2zM6 4v2h2v10H6v2H4v-2H2V6h2V4zm14 0v2h2v10h-2v2h-2v-2h-2V6h2V4zm-7-2v1.999h2V14h-2v2h-2v-2H9V4h2V2zM6 8H4v6h2zm14 0h-2v6h2zm-7-2h-2v6h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartStock as ChartStock };
